export const CLIENT_ACTIVITY_LIMIT = 500;

export const getClientQueryVariables = (id) => ({
	id,
	classesLimit: CLIENT_ACTIVITY_LIMIT,
	storeVisitsLimit: CLIENT_ACTIVITY_LIMIT,
});
